import { THEME } from '@pkg/config/misc/theme';

export function alternateTheme(theme: THEME) {
  const themeAlts = {
    [THEME.DARK]: THEME.DARK_ALT,
    [THEME.DARK_ALT]: THEME.DARK,
    [THEME.LIGHT]: THEME.LIGHT_ALT,
    [THEME.LIGHT_ALT]: THEME.LIGHT,
  }

  return themeAlts[theme];
}

export function contrastingTheme(theme: THEME) {
  const contrastingThemes = {
    [THEME.DARK]: THEME.LIGHT,
    [THEME.DARK_ALT]: THEME.LIGHT,
    [THEME.LIGHT]: THEME.DARK,
    [THEME.LIGHT_ALT]: THEME.DARK,
  }

  return contrastingThemes[theme] ?? THEME.DARK;
}
